import Component from './Media.vue';

export default {
  install(Vue) {
    Vue.component('BkfCardMedia', Component);
  },
};
